/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { SimTypography } from 'components/SimTypography';

const Vision = () => {
	const theme = useTheme();

	return (
		<Box>
			<SimTypography
				variant='h2'
				align={'center'}
				gutterBottom
				sx={{
					fontWeight: 900,
					color: theme.palette.common.white,
					textTransform: 'uppercase'
				}}>
				Our Vision
			</SimTypography>
			<SimTypography
				variant='h6'
				component='p'
				align={'center'}
				sx={{
					color: theme.palette.common.white
				}}>
				To be the helping hand in making life better for neuro diverse children and their parents
			</SimTypography>
		</Box>
	);
};

export default Vision;
